module.exports = __webpack_public_path__ + "static/media/user_details_active.a1d54fc5.svg";